import { useAuth } from 'react-oidc-context'
import { Button, DialogActions, DialogContent, DialogContentText } from '@mui/material'
import { useSnackbar } from 'notistack'

import { useHost } from '../../providers/app-provider'
import { DeviceTableRow } from '../../routes/accounts/components/devices-tab-panel/types'
import Api from '../../utils/api'
import DialogWithTitle from '../dialog-with-title'

interface DeviceUnpauseModalProps {
  devices: DeviceTableRow[] | IDeviceAPIObject[]
  open: boolean
  onClose: () => void
  onContinue: () => void
}

const DeviceUnpauseModal = ({ devices, open, onClose, onContinue }: DeviceUnpauseModalProps) => {
  const { enqueueSnackbar } = useSnackbar()
  const auth = useAuth()
  const host = useHost()

  const onConfirm = async () => {
    if (!host || !auth.user?.access_token) return
    const res = await Api.post(`${host}/api/v2/nodes/reactions/resume`, {
      deviceIds: devices.map((d) => d.id),
    })
    if (res.ok) {
      onContinue()
      onClose()
      enqueueSnackbar(`Device${devices.length > 1 ? 's' : ''} unpaused successfully.`)
    } else {
      enqueueSnackbar(`Could not unpause device${devices.length > 1 ? 's' : ''}.`, { variant: 'error' })
    }
  }

  return (
    <DialogWithTitle open={open} title="Unpause" setOpen={onClose}>
      <DialogContent>
        <DialogContentText>By pressing confirm, you will unpause selected device(s) immediately.</DialogContentText>
        <DialogActions sx={{ marginTop: 2, marginBottom: 2 }}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onConfirm}>
            Confirm
          </Button>
        </DialogActions>
      </DialogContent>
    </DialogWithTitle>
  )
}

export default DeviceUnpauseModal
